import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AppWideUser, Token } from "../Services/AppUserProfile";
import { Router } from "@angular/router";

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {

  constructor(private router: Router, private cookieService: CookieService, private appUserDetails: AppWideUser, private token: Token) {

    if ((this.appUserDetails.UserName == undefined && this.token.access_token == undefined) || (this.appUserDetails.UserName == null && this.token.access_token == null)) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token')) {

        this.appUserDetails = JSON.parse(this.cookieService.get('AppWideUser'));
      }

      try {
       
        this.token = JSON.parse(this.cookieService.get('Token'));
      } catch (err) {
        // 👇️ SyntaxError: Unexpected end of JSON input
        //console.log('error', err);
        this.router.navigate(["login"]);
      }
     
     
    }

  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/layout/layout.component.ts